export enum DataRelationTypeEnum {
  Outgoing = 0,
  Incoming = 1,
}
